import useId from '../utils/useId';
import * as React from 'react';
export const alipayhkSvg = React.forwardRef(function alipayhkSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_alipayhk__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#fff',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M32 0v21.36c-.3-.076-2.226-.506-6.06-1.793-1.199-.386-2.764-.972-4.477-1.607 1.018-1.778 1.853-3.847 2.41-6.084h-5.797V9.81h7.06V8.662h-7.06V5.22h-2.87c-.482 0-.512.424-.515.457v2.986H7.572V9.81h7.175v2.066H8.836v1.148h11.421a19.265 19.265 0 0 1-1.664 3.96c-3.693-1.181-7.657-2.181-10.159-1.55-1.601.369-2.61 1.058-3.214 1.78-2.804 3.346-.821 8.38 5.05 8.38 3.448 0 6.786-1.896 9.356-5.051C23.191 22.245 30.854 25.522 32 26v6H0V15.238L15.195 0h16.806Z',
        fill: '#00A0E9',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9.697 23.707c-4.538 0-5.895-3.551-3.616-5.468.75-.67 2.107-.98 2.812-1.036 2.742-.288 5.249.746 8.208 2.187-2.054 2.627-4.735 4.317-7.404 4.317Z',
        fill: '#00A0E9',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M15.345 0 0 15.345V0h15.345Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm6.308 6.832-.35.35-1.281-1.283-1.538 1.538L4.42 8.72l-.35.35-2.816-2.816.35-.35 1.218 1.218L4.36 5.583 3.143 4.366l.35-.35 2.815 2.816Zm.717-.717-.053.053-.122.122-.122.122-.053.053L3.86 3.649l.35-.35 1.373 1.374.02-.02-.137-2.61.44-.44L6.003 4l2.823.314-.446.446-2.37-.268.032.639.984.983Z',
        fill: '#00A0E9',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_alipayhk__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
    ),
  );
});
alipayhkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alipayhk = {
  category: 'brand',
  colorable: false,
  name: 'alipayhk',
  svg: alipayhkSvg,
};
